import { Link } from "react-router-dom";
import TopBar from "../../components/layout/TopBar";
import BottomNav from "../../components/layout/BottomNav";
import { IMG } from "../../utils/images";

export default function ComingSoon({ title, sub, image }) {
  return (
    <div className="app-page" data-testid="coming-soon">
      <TopBar title={title} back showProfile={false} />
      <main className="max-w-2xl mx-auto px-4 pt-3">
        <div className="relative h-[70vh] rounded-[16px] overflow-hidden">
          <img src={image || IMG.yoga} alt="" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0.92) 100%)" }} />
          <div className="absolute bottom-8 left-6 right-6 text-white">
            <div className="text-[12px] uppercase tracking-wider opacity-80">Coming soon</div>
            <h2 className="font-display text-[36px] sm:text-[40px] leading-tight mt-1">{title}</h2>
            <p className="text-[14px] mt-2 text-white/85 max-w-md">{sub}</p>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                alert("Thanks — we'll notify you the moment it's live.");
              }}
              className="mt-5 flex gap-2 max-w-md"
            >
              <input
                type="email"
                placeholder="you@example.com"
                required
                data-testid="notify-email"
                className="flex-1 h-11 rounded-pill px-4 bg-white/10 border border-white/30 text-white placeholder:text-white/60 outline-none"
                style={{ borderRadius: 100 }}
              />
              <button
                type="submit"
                data-testid="notify-submit"
                className="px-5 h-11 rounded-pill font-medium"
                style={{ background: "var(--accent-green)", color: "#000", borderRadius: 100 }}
              >
                Notify Me
              </button>
            </form>
          </div>
        </div>
        <Link to="/home" className="block text-center mt-6 text-[14px] text-ink underline-offset-4 hover:underline">
          Back to home
        </Link>
      </main>
      <BottomNav />
    </div>
  );
}
